import { React } from "react";
import { Box, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ScheduleAuditVisitAgent from "../../../dashboard/agent-dashboard/Manage-Audit/scheduleAuditVisitAgent";
import { useTranslation } from "react-i18next";

const ScheduleVisitAuditDialog = ({
  scheduleAppointment,
  setScheduleAppointment,
  id,
}) => {
  const { t } = useTranslation();
  const dialogCloseHandler = () => {
    setScheduleAppointment(false);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={scheduleAppointment}
        onClose={dialogCloseHandler}
        aria-labelledby="schedule-audit-dialog"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          {/* Header */}
          <Box
            sx={{
              background: "linear-gradient(135deg, #1A8CFF 0%, #0065CC 100%)",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="h6"
                sx={{
                  color: "#fff",
                  fontWeight: 700,
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "18px",
                  lineHeight: 1.3,
                }}
              >
                {t("Agent_dashboard.Manage Audit")}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "12px",
                  mt: 0.5,
                }}
              >
                {t("Agent_dashboard.Preference Date")}
              </Typography>
            </Box>
            <IconButton
              onClick={dialogCloseHandler}
              sx={{
                color: "#fff",
                backgroundColor: "rgba(255,255,255,0.15)",
                borderRadius: "10px",
                padding: "6px",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: "18px" }} />
            </IconButton>
          </Box>

          {/* Body */}
          <Box sx={{ padding: "28px" }}>
            <Box component="div" className="schedule-container">
              <ScheduleAuditVisitAgent
                id={id}
                setSchedAppointment={setScheduleAppointment}
              />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ScheduleVisitAuditDialog;
